import { ReactiveVar } from "@apollo/client";

export const setState = <T extends unknown>(state: ReactiveVar<T>, key: string, value: T): void => {
  state(value);
  localStorage.setItem(key, JSON.stringify(value));
};
